export default __webpack_public_path__ + "static/media/cn.e4f6436a.svg";